import { createFileRoute } from "@tanstack/react-router";
import { ApplicationSettingsPage } from "~/pages/ApplicationSettingsPage";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/applications")({
  component: ApplicationSettingsPage,
});
